import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobService } from 'src/app/services/job.service';
import { DatePipe } from "@angular/common";
import { FormGroup, FormBuilder, Validators, FormArray, MaxLengthValidator } from "@angular/forms";
import { ArrayValidators } from 'src/app/component/Array_validator/Array.validator'; // Import
import Swal from 'sweetalert2';
import { constrainPoint } from '@fullcalendar/core';
import { IMyOptions, IMyDate, IMyDateModel } from 'mydatepicker-th';
import { IMyDpOptions } from 'mydatepicker';
import { IJobEducation1, IJobEducation2, IJobEducation3, IJobEducation3License } from 'src/app/constants/models';
import { UtilsService } from 'src/app/services/utils.service';


@Component({
  selector: 'app-job-apply-education',
  templateUrl: './job-apply-education.component.html',
  styleUrls: ['./job-apply-education.component.scss']
})
export class JobApplyEducationComponent implements OnInit {
  lang = JSON.parse(localStorage.getItem('language'))
  defaultTitle = this.lang.jobchoose
  Laveleducation: any = [this.lang.jobedulevel1, this.lang.jobedulevel2,this.lang.jobedulevel4, this.lang.jobedulevel3];
  skill: any = [this.lang.jobeduskill1, this.lang.jobeduskill2, this.lang.jobeduskill3];
  month: any = [this.lang.month1, this.lang.month2, this.lang.month3, this.lang.month4, this.lang.month5, this.lang.month6, this.lang.month7, this.lang.month8, this.lang.month9, this.lang.month10, this.lang.month11, this.lang.month12];

  submitted = false;

  // set icon
  Personal = true
  Education = false
  Family = false
  Experience = false
  childName: string;

  // check
  Education_1: boolean
  Education_2 = false
  Education_3 = false
  Education_4 = false
  Education_5 = false


  // Education_1
  personid: any
  education: any
  educationOther: any
  NameOfInstitute: any
  major: any
  graduate: any = ""
  FromMonthYear: any
  ToMonthYear: any
  FromMonth: any
  FromYear: any
  ToMonth: any
  ToYear: any
  gpa: any

  TMPeducation: any[] = []
  TMPNameOfInstitute: any

  formData: FormGroup;
  formDataLanguage: FormGroup;
  formDataLicense: FormGroup;
  formDataTraining: FormGroup;
  formDataComputerProgram: FormGroup;
  formDataOther: FormGroup;

  ssss: any;

  excisePersonInfo1: FormArray = new FormArray([]);
  LanguageInfo: FormArray = new FormArray([]);
  LicenseInfo: FormArray = new FormArray([]);
  TrainingInfo: FormArray = new FormArray([]);
  ComputerProgramInfo: FormArray = new FormArray([]);
  OtherInfo: FormArray = new FormArray([]);

  // Education_2
  speaking: any
  understanding: any
  reading: any
  writting: any

  language: any
  TMPlanguage: any
  file: any;
  file1: File[] = [];
  filePath: any[] = [];
  selectedFeatures: any = [];

  fileToUpload: File = null;
  Filenames: any[] = [];
  // Education_3
  licenseName: any
  licenseNo: any
  licenseDate: any

  training_subject: any
  training_institute: any
  training_period: any

  // Education_4
  ComputerProgram: any = ""
  other: any = ""

  count = 1
  clickCount = 0
  countEducation = 1
  countLanguage = 1
  countLicense = 1
  countTraining = 1
  dateFormatted: string
  clickAdd: any

  // Req
  Reqeducation = false
  ReqeducationOther = false
  ReqNameOfInstitute = false
  Reqmajor = false
  Reqgraduate = false
  ReqFromMonthYear = false
  ReqFromMonth = false
  ReqFromYear = false
  ReqToMonthYear = false
  ReqToMonth = false
  ReqToYear = false
  Reqgpa = false
  Reqlanguage = false
  Reqfile1 = false
  ReqlicenseName = false
  Reqspeaking = false
  Requnderstanding = false
  Reqreading = false
  Reqwritting = false
  ReqlicenseNo = false
  ReqlicenseDate = false
  ReqComputerProgram = false
  Reqother = false
  ReqSubject = false
  ReqInstitute = false
  ReqPeriod = false

  checkOther = false
  flagOther: any[] = [];

  flag: any

  myDatePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
  }

  myDatePickerOptionsEN: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    // private datePipe: DatePipe,
    private _JobApplyService: JobService,
    private utils: UtilsService
  ) {
    this.createform();   ///function  เรียกฟอรม
  }

  createItemAssign(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      education: [],
      educationOther: [],
      major: [],
      FromMonthYear: [],
      ToMonthYear: [],
      FromMonth: [],
      FromYear: [],
      ToMonth: [],
      ToYear: [],
      // graduate: [],
      NameOfInstitute: [],
      gpa: []
    });
  }



  createItemLanguage(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      language: [],
      file1: [],
      speaking: [],
      understanding: [],
      reading: [],
      writting: []
    });
  }

  createItemLicense(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      licenseName: [],
      licenseNo: [],
      licenseDate: []
    });
  }
  createItemTraining(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      training_subject: [],
      training_institute: [],
      training_period: []
    });
  }
  createItemComputerProgram(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      ComputerProgram: []
    });
  }

  createItemother(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      other: []
    });
  }

  createform() {   ///form data

    this.formData = this.fb.group({
      excisePersonInfo1: this.fb.array([this.createItemAssign(), this.createItemAssign()]),
    })

    this.formDataLanguage = this.fb.group({
      LanguageInfo: this.fb.array([this.createItemLanguage()]),
    })

    this.formDataLicense = this.fb.group({
      LicenseInfo: this.fb.array([this.createItemLicense()]),
    })

    this.formDataTraining = this.fb.group({
      TrainingInfo: this.fb.array([this.createItemTraining()]),
    })

    this.formDataComputerProgram = this.fb.group({
      ComputerProgramInfo: this.fb.array([this.createItemComputerProgram()]),
    })

    this.formDataOther = this.fb.group({
      OtherInfo: this.fb.array([this.createItemother()]),
    })
  }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")
    var personid = localStorage.getItem("personid");
    localStorage.removeItem("licenseDate");
    this.clickCount = 1;

    this.formData = this.fb.group({
      excisePersonInfo1: this.fb.array([this.createItemAssign()]),
    })
    this.formDataLanguage = this.fb.group({
      LanguageInfo: this.fb.array([this.createItemLanguage()]),
    })

    this.formDataLicense = this.fb.group({
      LicenseInfo: this.fb.array([this.createItemLicense()]),
    })

    this.formDataTraining = this.fb.group({
      TrainingInfo: this.fb.array([this.createItemTraining()]),
    })

    this.formDataOther = this.fb.group({
      OtherInfo: this.fb.array([this.createItemother()]),
    })
    // this.mockupData()
  }

  addEducations() {
    // this.count = this.count + 1;

    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.countEducation += 1

    this.excisePersonInfo1 = this.formData.controls.excisePersonInfo1 as FormArray;

    this.excisePersonInfo1.push(this.fb.group({
      education: [],
      educationOther: [],
      major: [],
      FromMonthYear: [],
      ToMonthYear: [],
      FromMonth: [],
      FromYear: [],
      ToMonth: [],
      ToYear: [],
      // graduate: [],
      NameOfInstitute: [],
      gpa: []
    }));
  }

  removeEducation() {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));
    this.excisePersonInfo1.removeAt(this.excisePersonInfo1.length - 1);
    this.countEducation -= 1;
  }

  addLanguage() {
    // this.count = this.count + 1;

    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.countLanguage += 1;

    this.LanguageInfo = this.formDataLanguage.controls.LanguageInfo as FormArray;

    this.LanguageInfo.push(this.fb.group({
      language: [],
      file1: [],
      speaking: [],
      understanding: [],
      reading: [],
      writting: []
    }));
  }

  removeLanguage(i) {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));

    this.LanguageInfo.removeAt(this.LanguageInfo.length - 1);
    // this.Filenames.removeAt(this.Filenames.length);

    this.Filenames.splice(i, 1);
    // this.clickCount = this.clickCount - 1;
    this.countLanguage -= 1;
  }

  addLicense() {
    // this.count = this.count + 1;

    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.countLicense += 1;
    this.LicenseInfo = this.formDataLicense.controls.LicenseInfo as FormArray;

    this.LicenseInfo.push(this.fb.group({
      licenseName: [],
      licenseNo: [],
      licenseDate: []
    }));
  }

  removeLicense() {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));
    this.LicenseInfo.removeAt(this.LicenseInfo.length - 1);
    this.countLicense -= 1;
  }
  addTraining() {
    // this.count = this.count + 1;

    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.countTraining += 1;
    this.TrainingInfo = this.formDataTraining.controls.TrainingInfo as FormArray;

    this.TrainingInfo.push(this.fb.group({
      training_subject: [],
      training_institute: [],
      training_period: []
    }));
  }

  removeTraining() {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));
    this.TrainingInfo.removeAt(this.TrainingInfo.length - 1);
    this.countTraining -= 1;
  }
  addComputer() {
    this.count = this.count + 1;

    this.clickCount = this.count;
    localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.ComputerProgramInfo = this.formDataComputerProgram.controls.ComputerProgramInfo as FormArray;

    this.ComputerProgramInfo.push(this.fb.group({
      ComputerProgram: []
    }));
  }

  removeComputer() {
    var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));

    this.ComputerProgramInfo.removeAt(this.ComputerProgramInfo.length - 1);
    this.clickCount = this.clickCount - 1;
  }

  addOther() {
    this.count = this.count + 1;

    this.clickCount = this.count;
    localStorage.setItem("clickCount", JSON.stringify(this.clickCount));

    this.OtherInfo = this.formDataOther.controls.OtherInfo as FormArray;
    this.OtherInfo.push(this.fb.group({
      other: []
    }));
  }

  removeOther() {
    var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));

    this.OtherInfo.removeAt(this.OtherInfo.length - 1);
    this.clickCount = this.clickCount - 1;
  }

  goback() {
    this.router.navigate(['/job-apply']);
  }

  // File(event) {
  //   this.file1 = <File>event.target.files[0]
  // }

  getFile(fileInput, i) {

    var a = '' + <File>fileInput.target.files[0].name.split('.')[1]

    if (a == "pdf" || a == "jpg" || a == "docx" || a == "png") {
      this.Filenames.push(fileInput.target.files[0]);
      // this.file1 = fileInput.target.files[0].name;
      this.fileToUpload = fileInput.target.files[0];
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Cannot Choose file',
        text: 'Please Choose file type PDF,DOCX,JPG,PNG!',
      })
    }
  }

  UploadFile(i) {
    if (this.fileToUpload == null) {

      Swal.fire({
        icon: 'error',
        title: 'Cannot Choose file',
        text: 'Please Choose file before Upload',
      })
    } else {

      Swal.fire({
        position: 'top-end',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this._JobApplyService.UploadFile_education(this.Filenames[i]).subscribe(result => {
        this.filePath[i] = result;
      })
    }
  }

  Delete(i) {
    this.Filenames.splice(i, 1);
    this.filePath.splice(i, 1);
  }

  transform(value: string) {
    let datePipe = new DatePipe("en-US");
    value = datePipe.transform(value, 'yyyy-MM-dd');
    if (this.flag == 'th') {
      var date = value.split('-');
      date[0] = String(Number(date[0]) + 543);
      value = date.join('-')
    }
    localStorage.setItem("licenseDate", value);
    return value
  }

  onDateChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
  }

  onDateFromChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    localStorage.setItem("FromMonthYear", this.dateFormatted);
  }

  onDateToChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    localStorage.setItem("ToMonthYear", this.dateFormatted);
  }

  onDatelicenseChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    localStorage.setItem("licenseDate", this.dateFormatted);
  }

  goFamily() {

    this.submitted = true;
    var personid = localStorage.getItem("personid");

    if (personid != "") {

      var arrayControl = this.formData.value.excisePersonInfo1;
      for (let i = 0; this.formData.controls.excisePersonInfo1['length'] > i; i++) {

        if (this.FromMonth === undefined || this.FromMonth === '' || this.FromMonth === null) {
          this.ReqFromMonth = true;
        } else {
          this.ReqFromMonth = false;
        }

        if (this.FromYear === undefined || this.FromYear === '' || this.FromYear === null) {
          this.ReqFromYear = true;
        } else {
          this.ReqFromYear = false;
        }

        if (this.ToMonth === undefined || this.ToMonth === '' || this.ToMonth === null) {
          this.ReqToMonth = true;
        } else {
          this.ReqToMonth = false;
        }

        if (this.ToYear === undefined || this.ToYear === '' || this.ToYear === null) {
          this.ReqToYear = true;
        } else {
          this.ReqToYear = false;
        }

        var FromMonthYear = localStorage.getItem("FromMonthYear");
        var ToMonthYear = localStorage.getItem("ToMonthYear");

        this.education = arrayControl[i].education;
        this.educationOther = arrayControl[i].educationOther;
        this.NameOfInstitute = arrayControl[i].NameOfInstitute;
        this.major = arrayControl[i].major;
        // this.graduate = arrayControl[i].graduate;
        this.gpa = arrayControl[i].gpa;
        this.FromMonth = arrayControl[i].FromMonth;
        this.FromYear = arrayControl[i].FromYear;
        this.ToMonth = arrayControl[i].ToMonth;
        this.ToYear = arrayControl[i].ToYear;

        if (this.FromMonth === undefined || this.FromMonth === '' || this.FromMonth === null) {
          this.ReqFromMonth = true;
        } else {
          this.ReqFromMonth = false;
        }

        if (this.FromYear === undefined || this.FromYear === '' || this.FromYear === null) {
          this.ReqFromYear = true;
        } else {
          this.ReqFromYear = false;
        }

        if (this.ToMonth === undefined || this.ToMonth === '' || this.ToMonth === null) {
          this.ReqToMonth = true;
        } else {
          this.ReqToMonth = false;
        }

        if (this.ToYear === undefined || this.ToYear === '' || this.ToYear === null) {
          this.ReqToYear = true;
        } else {
          this.ReqToYear = false;
        }

        if (this.NameOfInstitute === undefined || this.NameOfInstitute === '' || this.NameOfInstitute === null) {
          this.ReqNameOfInstitute = true;
        } else {
          this.ReqNameOfInstitute = false;
        }

        if (this.education === undefined || this.education === '' || this.education === null) {
          this.Reqeducation = true;
        } else {
          this.Reqeducation = false;
        }


        // console.log("this.educationOther ", this.educationOther);

        if (this.flagOther[i]) {
          if (this.educationOther === undefined || this.educationOther === '' || this.educationOther === null) {
            this.ReqeducationOther = true;
          } else {
            this.ReqeducationOther = false;
          }
        }

        if (this.major === undefined || this.major === '' || this.major === null) {
          this.Reqmajor = true;
        } else {
          this.Reqmajor = false;
        }

        // if (this.graduate === undefined || this.graduate === '' || this.graduate === null) {
        //   this.Reqgraduate = true;
        // } else {
        //   this.Reqgraduate = false;
        // }

        if (this.gpa === undefined || this.gpa === '' || this.gpa === null) {
          // this.Reqgpa = true;
          this.Reqgpa = true;
        } else {
          this.Reqgpa = false;
        }
      }

      if (this.Reqgpa === false && this.Reqmajor === false &&
        this.Reqeducation === false && this.ReqeducationOther === false &&
        this.ReqNameOfInstitute === false && this.ReqToMonth === false &&
        this.ReqToYear === false && this.ReqFromMonth === false && this.ReqFromYear === false) {
        this.Education_1 = true;
      } else {
        this.Education_1 = false
      }

      var arrayControlLanguage = this.formDataLanguage.value.LanguageInfo;
      for (let i = 0; this.formDataLanguage.controls.LanguageInfo['length'] > i; i++) {

        this.language = arrayControlLanguage[i].language;
        this.speaking = arrayControlLanguage[i].speaking;
        this.understanding = arrayControlLanguage[i].understanding;
        this.reading = arrayControlLanguage[i].reading;
        this.writting = arrayControlLanguage[i].writting;
        this.file1 = arrayControlLanguage[i].file1;

        //var file1 = localStorage.getItem("file1");

        if (this.language === undefined || this.language === '' || this.language === null) {
          this.Reqlanguage = true;
        } else {
          this.Reqlanguage = false;
        }

        if (this.speaking === undefined || this.speaking === '' || this.speaking === null) {
          this.Reqspeaking = true;
        } else {
          this.Reqspeaking = false;
        }

        if (this.understanding === undefined || this.understanding === '' || this.understanding === null) {
          this.Requnderstanding = true;
        } else {
          this.Requnderstanding = false;
        }

        if (this.reading === undefined || this.reading === '' || this.reading === null) {
          this.Reqreading = true;
        } else {
          this.Reqreading = false;
        }

        if (this.writting === undefined || this.writting === '' || this.writting === null) {
          this.Reqwritting = true;
        } else {
          this.Reqwritting = false;
        }

        if (this.Reqwritting === false && this.Reqreading === false && this.Requnderstanding === false &&
          this.Reqspeaking === false && this.Reqlanguage === false) {
          this.Education_2 = true
        } else {
          this.Education_2 = false
        }
      }

      if (this.Education_1 === true && this.Education_2 === true) {
        this.edu1();
        this.edu2();
        this.edu3();
        this.edu4();
        this.router.navigate(['/job-apply-family']);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Cannot Next Step',
          text: 'กรุณากรอกข้อมูลที่จำเป็นให้ครบ',
        })
      }
    }
  }
  edu1() {
    var arrayControl = this.formData.value.excisePersonInfo1;
    var personid = localStorage.getItem("personid");

    let i = 0

    if (this.formData.value) {
      const params: IJobEducation1[] = []
      while (i < this.formData.controls.excisePersonInfo1['length']) {

        if (this.FromMonth === undefined || this.FromMonth === '' || this.FromMonth === null) {
          this.ReqFromMonth = true;
        } else {
          this.ReqFromMonth = false;
        }

        if (this.FromYear === undefined || this.FromYear === '' || this.FromYear === null) {
          this.ReqFromYear = true;
        } else {
          this.ReqFromYear = false;
        }

        if (this.ToMonth === undefined || this.ToMonth === '' || this.ToMonth === null) {
          this.ReqToMonth = true;
        } else {
          this.ReqToMonth = false;
        }

        if (this.ToYear === undefined || this.ToYear === '' || this.ToYear === null) {
          this.ReqToYear = true;
        } else {
          this.ReqToYear = false;
        }

        // var FromMonthYear = localStorage.getItem("FromMonthYear");
        // var ToMonthYear = localStorage.getItem("ToMonthYear");

        this.education = arrayControl[i].education;
        this.educationOther = arrayControl[i].educationOther || '';
        this.NameOfInstitute = arrayControl[i].NameOfInstitute;
        this.major = arrayControl[i].major;
        // this.graduate = arrayControl[i].graduate;
        this.gpa = arrayControl[i].gpa;
        this.FromMonth = arrayControl[i].FromMonth;
        this.FromYear = arrayControl[i].FromYear;
        this.ToMonth = arrayControl[i].ToMonth;
        this.ToYear = arrayControl[i].ToYear;

        if (this.FromMonth === undefined || this.FromMonth === '' || this.FromMonth === null) {
          this.ReqFromMonth = true;

        } else {
          this.ReqFromMonth = false;
        }

        if (this.FromYear === undefined || this.FromYear === '' || this.FromYear === null) {
          this.ReqFromYear = true;

        } else {
          this.ReqFromYear = false;
        }

        if (this.ToMonth === undefined || this.ToMonth === '' || this.ToMonth === null) {
          this.ReqToMonth = true;
        } else {
          this.ReqToMonth = false;
        }

        if (this.ToYear === undefined || this.ToYear === '' || this.ToYear === null) {
          this.ReqToYear = true;
        } else {
          this.ReqToYear = false;
        }

        if (this.NameOfInstitute === undefined || this.NameOfInstitute === '' || this.NameOfInstitute === null) {
          this.ReqNameOfInstitute = true;
        } else {
          this.ReqNameOfInstitute = false;
        }

        if (this.education === undefined || this.education === '' || this.education === null) {
          this.Reqeducation = true;
        } else {
          this.Reqeducation = false;
        }

        if (this.checkOther) {
          if (this.educationOther === undefined || this.educationOther === '' || this.educationOther === null) {
            this.ReqeducationOther = true;
          } else {
            this.ReqeducationOther = false;
          }
        }


        if (this.major === undefined || this.major === '' || this.major === null) {
          this.Reqmajor = true;
        } else {
          this.Reqmajor = false;
        }

        // if (this.graduate === undefined || this.graduate === '' || this.graduate === null) {
        //   this.Reqgraduate = true;
        // } else {
        //   this.Reqgraduate = false;
        // }

        if (this.gpa === undefined || this.gpa === '' || this.gpa === null) {
          // this.Reqgpa = true;
          this.Reqgpa = true;
        } else {
          this.Reqgpa = false;
        }

        if (this.Reqgpa == false || this.Reqmajor == false ||
          this.Reqeducation == false || this.ReqeducationOther == false || this.ReqNameOfInstitute == false || this.ReqToMonth == false || this.ReqToYear == false || this.ReqFromMonth == false || this.ReqFromYear == false) {
          this.Education_1 = true
          if (this.FromMonth.length == 2) {
            var FromMonthYear = this.FromMonth + "/" + this.FromYear
          } else {
            var FromMonthYear = "0" + this.FromMonth + "/" + this.FromYear
          }

          if (this.ToMonth.length == 2) {
            var ToMonthYear = this.ToMonth + "/" + this.ToYear
          } else {
            var ToMonthYear = "0" + this.ToMonth + "/" + this.ToYear
          }
          params.push(
            { personid: personid, education: this.education, NameOfInstitute: this.NameOfInstitute, major: this.major, graduate: this.graduate, FromMonthYear: FromMonthYear, ToMonthYear: ToMonthYear, gpa: this.gpa, seq: (i + 1).toString(), educationOther: this.educationOther })
          // let edu1 = this._JobApplyService.setEducation_1(personid, this.education, this.NameOfInstitute, this.major, this.graduate, FromMonthYear, ToMonthYear, this.gpa, i + 1, this.educationOther).subscribe(result => {

          //   if (result.returncode == "3800") {
          //     return alert('Education_1ไม่ผ่าน');
          //   }
          // })
        }
        i++
      }
      console.log('setEducations_1');
      
      this._JobApplyService.setEducations_1(params).subscribe(result => {
        if (result.returncode == "3800") {
          console.log(result.desc);  
          // return alert('Education_1ไม่ผ่าน');
        }
      })
      this.Education_1 == true
    }
  }

  edu2() {
    var personid = localStorage.getItem("personid");
    const params: IJobEducation2 = { personid: personid, language_edus2: [], training_edus2: [] }
    if (this.formDataLanguage.value) {

      let i = 0

      var arrayControlLanguage = this.formDataLanguage.value.LanguageInfo;

      while (i < this.formDataLanguage.controls.LanguageInfo['length']) {

        this.language = arrayControlLanguage[i].language;
        this.speaking = arrayControlLanguage[i].speaking;
        this.understanding = arrayControlLanguage[i].understanding;
        this.reading = arrayControlLanguage[i].reading;
        this.writting = arrayControlLanguage[i].writting;
        this.file1 = this.filePath[i] || ""

        var file1 = localStorage.getItem("file1");

        if (this.language === undefined || this.language === '' || this.language === null) {
          this.Reqlanguage = true;
        } else {
          this.Reqlanguage = false;
        }

        // if (this.Reqspeaking == true) {
        //   this.Reqfile1 = true;
        // } else {
        //   this.Reqfile1 = false;
        // }

        if (this.speaking === undefined || this.speaking === '' || this.speaking === null) {
          if (file1 == undefined || file1 == '' || file1 == null) {
            this.Reqspeaking = true;
          }
        } else {
          this.Reqspeaking = false;
        }

        if (this.understanding === undefined || this.understanding === '' || this.understanding === null) {
          if (file1 == undefined || file1 == '' || file1 == null) {
            this.Requnderstanding = true;
          }
        } else {
          this.Requnderstanding = false;
        }

        if (this.reading === undefined || this.reading === '' || this.reading === null) {
          if (file1 == undefined || file1 == '' || file1 == null) {
            this.Reqreading = true;
          }
        } else {
          this.Reqreading = false;
        }

        if (this.writting === undefined || this.writting === '' || this.writting === null) {
          if (file1 == undefined || file1 == '' || file1 == null) {
            this.Reqwritting = true;
          }
        } else {
          this.Reqwritting = false;
        }

        if (this.Reqwritting == false || this.Reqreading == false || this.Requnderstanding == false ||
          this.Reqspeaking == false || this.Reqlanguage == false) {
          this.Education_2 = true
          params.language_edus2.push({ file1: file1, language: this.language, speaking: this.speaking, understanding: this.understanding, reading: this.reading, writting: this.writting, seq: (i + 1).toString() })
        }
        i++
      }
      this.Education_2 == true
    }
    if (this.formDataTraining.value) {

      let i = 0

      var arrayControlTraining = this.formDataTraining.value.TrainingInfo;

      while (i < this.formDataTraining.controls.TrainingInfo['length']) {

        this.training_subject = arrayControlTraining[i].training_subject;
        this.training_institute = arrayControlTraining[i].training_institute;
        this.training_period = arrayControlTraining[i].training_period;

        this.ReqSubject  = this.utils.isNullOrUndefined(this.training_subject);
        this.ReqInstitute  = this.utils.isNullOrUndefined(this.training_institute);
        this.ReqPeriod  = this.utils.isNullOrUndefined(this.training_period);

        if (!this.ReqSubject || !this.ReqInstitute == false || !this.ReqPeriod) {
          params.training_edus2.push({ training_subject: this.training_subject, training_institute: this.training_institute, training_period: this.training_period, seq: (i + 1).toString() })
        }
        i++
      }
    }
    this._JobApplyService.setEducations_2(params).subscribe(result => {
            if (result.returncode == "3800") {
              console.log(result.desc);  
              // return alert('Education_2ไม่ผ่าน');
              // this.router.navigate(['/job-apply-family']);
            }
          })
          this.Education_2 = true
  }

  edu3() {
    const dateString = '1900/01/01 00:00:00';
    var personid = localStorage.getItem("personid");
    if (this.formDataLicense.value) {
      const education3:IJobEducation3 = {personid:personid,licenses:[]}
      var i = 0;
      var arrayControlLicense = this.formDataLicense.value.LicenseInfo;

      while (i < this.formDataLicense.controls.LicenseInfo['length']) {
        if (this.licenseDate === undefined || this.licenseDate === '' || this.licenseDate === null) {
          this.ReqlicenseDate = true;
        } else {
          this.ReqlicenseDate = false;
        }

        this.licenseName = arrayControlLicense[i].licenseName || "";
        this.licenseNo = arrayControlLicense[i].licenseNo || "";
        this.licenseDate = arrayControlLicense[i].licenseDate || "";
        let _licenseDate = ''
        // this.onDatelicenseChanged(this.licenseDate)
        if (this.licenseDate != '') {
          _licenseDate = localStorage.getItem("licenseDate");
        } else {
          _licenseDate = dateString;
        }
        education3.licenses.push({license_name:this.licenseName,license_no:this.licenseNo,license_date:_licenseDate,seq:(i+1).toString()});        
        i++
      }
      this._JobApplyService.setEducations_3(education3).subscribe(result => {
        
        if (result.returncode == "1000") {
          this.Education_3 = true
        }else{
          console.log(result.desc);              
        }
      })
    }
  }

  edu4() {
    var personid = localStorage.getItem("personid");

    var arrayControComputerProgram = this.formDataComputerProgram.value.ComputerProgramInfo;
    var arrayControOther = this.formDataOther.value.OtherInfo;
    var ComputerProgramInfo = this.formDataComputerProgram.value.ComputerProgramInfo.length;
    var OtherInfo = this.formDataOther.value.OtherInfo.length;

    var check = changearray(ComputerProgramInfo, OtherInfo);
    var sumOther = arrayControOther.length;
    var sumComputerProgram = arrayControComputerProgram.length;

    for (let i = 0; i < sumComputerProgram; i++) {

      this.ComputerProgram = arrayControComputerProgram[i].ComputerProgram;
      this.other = arrayControOther[i].other;

      let obj = {
        "personid": personid,
        "ComputerProgram": this.ComputerProgram,
        "other": this.other,
        "seq": i + 1,
      }

      this._JobApplyService.setEducation_4(obj).subscribe(result => {
      })
    }

    function changearray(ComputerProgramInfo, OtherInfo) {
      if (ComputerProgramInfo > OtherInfo) {
        for (let i = OtherInfo; i < ComputerProgramInfo; i++) {

          var x = {
            other: '',
          };

          arrayControOther.push(x);
        }

      } else if (OtherInfo > ComputerProgramInfo) {
        for (let i = ComputerProgramInfo; i < OtherInfo; i++) {

          var y = {
            ComputerProgram: '',
          };

          arrayControComputerProgram.push(y);
        }
      } else {
        return true;
      }
    }
  }

  setOther(i, value) {
    if (value == 'อื่น ๆ') {
      this.flagOther[i] = true
    } else {
      this.flagOther[i] = false
    }
    if (this.flagOther.includes(true)) {
      this.checkOther = true
    } else {
      this.checkOther = true
    }
  }

  setDateThai(date) {
    var newdate = date.split('-')
    newdate[0] = Number(newdate[0]) + 543
    date = newdate[0] + "-" + newdate[1] + "-" + newdate[2]
    return date;
  }
}